import React, { ReactNode } from 'react'
import closeModalIcon from '../../assets/closeModal.svg'
import classNames from 'classnames'

interface Props {
  isOpen: boolean
  children: ReactNode
  closeModal: () => void
}

const ModalBeneficiary = ({ isOpen, children, closeModal }: Props) => {
  if (!isOpen) return null

  return (
    <div
      className={classNames(
        'items-center flex fixed  z-20  inset-0  shadow-inner bg-[rgba(87,84,229,0.6)] backdrop-blur-[5px] w-full',
      )}
    >
      <div className="relative my-6 lg:my-0  mx-auto sm:w-full sm:mx-3 ">
        <div
          className={classNames(
            'border-0 shadow-lg py-3 px-[35px] sm:px-0  rounded-2xl flex flex-col w-full bg-white ',
          )}
        >
          <img
            src={closeModalIcon}
            width={20}
            height={20}
            onClick={() => {
              closeModal()
            }}
            className="right-2 absolute hover:cursor-pointer xs:w-[18px] m-[25px] sm:mx-2 sm:mt-3"
          />
          {children}
        </div>
      </div>
    </div>
  )
}

export default ModalBeneficiary
